<template>
  <section :class="[$style.root, { [$style.lpnh]: pageType === 'lpnh' }]">
    <div class="parts-container">
      <div :class="$style.thumb">
        <video
          v-if="pcUrl"
          :muted="pcVideoAutoPlay"
          playsinline
          :src="pcUrl"
          :autoplay="pcVideoAutoPlay"
          :preload="pcVideoAutoPlay ? 'auto' : 'none'"
          :loop="pcLoopPlayback"
          :controls="pcControls"
          class="page-parts-pc"
        ></video>
        <video
          v-if="spUrl"
          :muted="spVideoAutoPlay"
          playsinline
          :src="spUrl"
          :autoplay="spVideoAutoPlay"
          :preload="spVideoAutoPlay ? 'auto' : 'none'"
          :loop="spLoopPlayback"
          :controls="spControls"
          class="page-parts-sp"
        ></video>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
type Props = {
  pcUrl: string
  spUrl: string
  pcAutoPlay?: boolean
  spAutoPlay?: boolean
  pcLoopPlayback?: boolean
  spLoopPlayback?: boolean
  pcControls?: boolean
  spControls?: boolean
  pageType?: string
}

const props = withDefaults(defineProps<Props>(), {
  pcUrl: "",
  spUrl: "",
  pcAutoPlay: true,
  spAutoPlay: true,
  pcLoopPlayback: true,
  spLoopPlayback: true,
  pcControls: true,
  spControls: true,
  pageType: "",
})

const pcVideoAutoPlay = ref(false)
const spVideoAutoPlay = ref(false)

if (process.client) {
  if (window.innerWidth >= 768 && props.pcAutoPlay) {
    pcVideoAutoPlay.value = true
  }
  if (window.innerWidth < 768 && props.spAutoPlay) {
    spVideoAutoPlay.value = true
  }
}
</script>

<style scoped module lang="scss">
.root {
  @include container-lg;
  padding: 0;
  .thumb {
    width: 100%;
    overflow: hidden;
    video {
      width: 100%;
      object-fit: contain;
    }
  }
  &.lpnh {
    @include full-container-lg;
    .thumb {
      max-width: 720px;
    }
  }
}
</style>
